import { render, staticRenderFns } from "./sourcingmasterTF2.vue?vue&type=template&id=25fcc571&scoped=true"
import script from "./sourcingmasterTF2.vue?vue&type=script&lang=js"
export * from "./sourcingmasterTF2.vue?vue&type=script&lang=js"
import style0 from "./sourcingmasterTF2.vue?vue&type=style&index=0&id=25fcc571&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fcc571",
  null
  
)

export default component.exports